import React from 'react';
import Headers from './Headers';
import Cells from './Cells';
import Sidebar from './Sidebar';
import {Loader} from '@xpertdox_js/xdcomponents';
import BottomToolbar from './BottomToolbar';
import {ScrollContextProvider} from './Utils/ScrollContext';
import {DataTableContext} from './Utils/DataTableContext';
import {DragTableContext} from './Utils/DragTableContext';
import HeaderModal from './Headers/HeaderModal';
import InfoModal from './Headers/InfoModal';
import GroupActionMenu from './Headers/GroupActionMenu';

const DataTable = props => {
  const {handleStateUpdate, dtState, handleHeaderPlacement,
  handleDataRefresh, refreshTable} = React.useContext(DataTableContext);
  const {mouseDownEvent, mouseUpEvent, mouseOutEvent, dragEvent, refreshDrag} = React.useContext(DragTableContext);
  // Controller reference
  const {controller, data} = props;
  // styles
  let styles = props.styles;


  // create header list from header settings if not provided
  const tableHeaders = props.headers
    ? props.headers.slice()
    : Object.keys(props.headerSettings).slice();

  // controller state store
  const controllerInput = {
    // dtState: dtState,
    // master: props.data,
    // stateUpdate: handleStateUpdate,
    tableWidth: props.tableWidth,
    searchQuery: dtState.searchQuery,
    groupActions: props.spreadActions,
    userSetColumns: props.options.columns,
    headerInput: {
      ...controller.headerInput,
      headers: tableHeaders,
      settings: props.headerSettings
    },
    // data: props.data
  }

  const memoizedModals = React.useMemo(() =>
      <React.Fragment>
        <HeaderModal options={props.options} />
        <InfoModal options={props.options} />
        <GroupActionMenu options={props.options} />
      </React.Fragment>
  )

  // initial data setter when data is not null(loading state)
  React.useEffect(() => {
    if (dtState.tableData === null && data) {
      if (controller.data === null) {
        controller.registerData(props.data);
        controller.updateStore.tableData = controller.data.slice(0,20);
        // this above is added because after adding the contacts all the trials are added in the table
        // but we need to show the first 20 only after saving
      }

      Object.keys(controllerInput).forEach(key => controller[key] = controllerInput[key]);
      controller.render(!controller.refreshing);
      controller.refreshing = false;
    }

  }, [data, controller, controllerInput, dtState.tableData])

  // keep data up to date with props.data
  if (props.memo !== dtState.lastMemo) {
    controller.setGroupMenuInactive(false);
    refreshTable();
    refreshDrag();
  };

  if (props.data && controller.data && props.data.length > controller.data.length) {
    controller.registerData(props.data);
    controller.updateStore.tableData = controller.data.slice();
    controller.render(true);
  }
  const parsedData = {};
  if (dtState.tableData) dtState.tableData.forEach(dataID =>
    parsedData[dataID] = controller.master[dataID]
  );

  // get table element info for children dom measurements
  // console.log({controller: controller.data, tableDta: dtState.tableData, data})
  return <ScrollContextProvider tableElement={props.tableElement} data={dtState.tableData}>
    <div
      onMouseLeave={mouseOutEvent}
      onMouseMove={dragEvent}
      onMouseUp={mouseUpEvent}
    >

      {/* Table */}
      <div style={{
        ...styles.tableContainer,
        width: props.tableWidth
          ? props.tableWidth - 30 + 'px'
          : '100%',
        maxWidth: '100%'
      }}>

        { /* Headers */ }
        {dtState.tableData && controller.filteredHeaders &&
        <div style={styles.headersWrap}>
          <Headers
            dataKeys={dtState.tableData}
            data={parsedData}
            stateUpdate={handleStateUpdate}
            headers={controller.filteredHeaders}
            sortIndex={dtState.columnSortIndex}
            searchQuery={dtState.searchQuery}
            controller={controller}
            width={props.tableWidth - 30 + 'px'}
            dragWidth={props.tableWidth - 45 + 'px'}
            tableElement={props.tableElement}
            customTopOffset={props.options.customTopOffset}
            options={props.options}
            userDetails={props.userDetails}
          />
          {memoizedModals}
        </div>
        }

        { /* Cells */ }
        {((dtState.tableData) && controller.data)
          ? <div
              style={styles.cellsWrap}
              onMouseDown={mouseDownEvent}
            >
              <Cells
                dataKeys={dtState.tableData}
                data={parsedData}
                stateUpdate={handleStateUpdate}
                headers={controller.filteredHeaders || controller.headers}
                currentHeaders={controller.headerInput.currentHeaders}
                headerSettings={props.headerSettings}
                dropdown={props.dropdown}
                modal={props.modal}
                route={props.cellRoute}
                activeFetchParam={props.activeFetchParam}
                dataRefresh={handleDataRefresh}
                memo={props.memo}
                page={controller.page}
                history={props.history}
                location={props.location}
                routeSettings={props.routeSettings}
                cellRouteSettings={props.cellRouteSettings}
                actions={props.cellActions}
                width={props.tableWidth - 45 + 'px'}
                controller={controller}
                userDetails={props.userDetails}
              />
            </div>
          // show loader while waiting on data
          : <div style={styles.loaderWrap}>
              <Loader />
            </div>
        }
      </div>


      { /* Bottom Toolbar */ }
      {(!props.minDisplay && (controller.data || controller.filteredData)) &&
        <div style={styles.toolbarBottom}>
          <BottomToolbar
            controller={controller}
            data={controller.data}
            pageTotal={dtState.tableData ? dtState.tableData.length : null}
            total={Math.ceil(
              (controller.filteredData ? controller.filteredData.length : controller.data.length) / controller.pageLimit)}
            right={(controller.tableWidth + 30) / 2 + 'px'}
            width={controller.tableWidth - 30 + 'px'}
            tableElement={props.tableElement}
            scrollbarWidth={controller.tableWidth - 45 + 'px'}
          />
        </div>
      }

      { /* Sidebar */ }
      <div
        id={controller.tableID + '_sidebar'}
        style={styles.sidebarWrap}
      >
        <Sidebar
          toggleHeader={handleHeaderPlacement}
          headers={controller.headers}
          filteredHeaders={controller.filteredHeaders}
          settings={props.settings.menus.sidebar}
          stateUpdate={handleStateUpdate}
          currentHeaders={controller.headerInput.currentHeaders}
          memo={props.memo}
          tableElement={props.tableElement}
          data={dtState.tableData}
          customTopOffset={props.options.customTopOffset}
          options={props.options}
        />
      </div>
    </div>
    </ScrollContextProvider>;
}

export default DataTable;
